(() => {
  let scheduled = false;
  function update() {
    scheduled = false;
    const icon = document.getElementById('rawa-button');
    if (!icon) return;
    if (!window.matchMedia('(max-width: 749px)').matches) {
      icon.classList.remove('tilguti-whatsapp-collision');
      return;
    }
    const rect = icon.getBoundingClientRect();
    const actions = document.querySelectorAll('.product-form__submit, .product__info-container .st-wishlist-button, .cart__checkout-button');
    const overlaps = Array.from(actions).some((action) => {
      const box = action.getBoundingClientRect();
      return box.width > 0 && box.height > 0 && rect.left < box.right + 8 && rect.right > box.left - 8 && rect.top < box.bottom + 8 && rect.bottom > box.top - 8;
    });
    icon.classList.toggle('tilguti-whatsapp-collision', overlaps);
  }
  function schedule() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  }
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  const observer = new MutationObserver(() => {
    if (document.getElementById('rawa-button')) {
      observer.disconnect();
      schedule();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();